var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass:
        "hover:text-primary-600 focus:outline-none transition ease-in-out duration-150 inline-flex items-center",
      attrs: { href: _vm.url },
    },
    [
      _c(
        "svg",
        {
          staticClass: "w-6 md:mr-1 -mt-1",
          attrs: {
            fill: "none",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
          },
        },
        [
          _c("path", {
            attrs: { d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" },
          }),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "hidden md:inline" }, [
        _vm._v("(" + _vm._s(_vm.itemCount) + ")"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }